import { render, staticRenderFns } from "./HeaderH5.vue?vue&type=template&id=42ddaa19&scoped=true"
import script from "./HeaderH5.vue?vue&type=script&lang=js"
export * from "./HeaderH5.vue?vue&type=script&lang=js"
import style0 from "./HeaderH5.vue?vue&type=style&index=0&id=42ddaa19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ddaa19",
  null
  
)

export default component.exports